import {
  getGridNumericOperators,
  GridCellParams,
  GridFilterOperator,
  type GridFilterItem,
  type GridColDef,
} from '@mui/x-data-grid-pro'

let _multiNumOps: GridFilterOperator[]

const labelMapping = {
  '=': 'equal',
  '!=': 'not equal',
  '>': 'greater than',
  '>=': 'greater than or equal',
  '<': 'less than',
  '<=': 'less than or equal',
  isEmpty: 'is empty',
  isNotEmpty: 'is not empty',
  isAnyOf: 'is any of',
} as { [s: string]: string }

export function getGridNumericOperatorsWithText() {
  return getGridNumericOperators().map((o) => ({
    ...o,
    label: labelMapping[o.value] ? labelMapping[o.value] : o.value,
  }))
}

export default function getGridMultiNumberOperators() {
  if (!_multiNumOps)
    _multiNumOps = getGridNumericOperators().map((operator) =>
      operator.value === 'isEmpty' || operator.value === 'isNotEmpty'
        ? {
            ...operator,
          }
        : {
            ...operator,
            getApplyFilterFn: (
              filterItem: GridFilterItem,
              column: GridColDef,
            ) => {
              const singleNumberFilterFn = operator.getApplyFilterFn(
                { ...filterItem, value: Number(filterItem.value) },
                column,
              )
              // if there is not a filter value being applied to the column return true
              if (!filterItem.value || !singleNumberFilterFn) return () => true
              return (
                params: GridCellParams<
                  any,
                  Array<number | null | undefined> | null | undefined
                >,
              ) => {
                if (params.value === null || params.value === undefined)
                  return false
                const validParams = {
                  ...params,
                  value: params.value.filter(
                    (v) => typeof v === 'number' && !Number.isNaN(v),
                  ),
                }

                if (validParams.value.length > 0) {
                  return validParams.value.some((value) =>
                    singleNumberFilterFn({ ...params, value }),
                  )
                }
                return false
              }
            },
          },
    )
  return _multiNumOps
}
